/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import SearchButton from './SearchButton';
import suggestions from '../dummy_data/suggestions';

const SuggestedList = ({ data = suggestions, onGetSuggestion }) => {
    // eslint-disable-next-line react/react-in-jsx-scope
    let content = <p>Sorry, no suggestions found</p>;

    if (data.length > 1) {
        content = suggestions.map((item) => (
            <SearchButton
                href={item.url}
                key={item.id}
                onGetSuggestion={onGetSuggestion}
            >
                {item.name}
            </SearchButton>
        ));
    }
    return (
        <div className="search-suggestions__wrapper">
            <div className="search-suggestions__container">
                <div className="search-suggestions__row">
                    <header className="search-suggestions__header">
                        <h4>Suggested Searches</h4>
                    </header>
                    <div className="search-suggestions__buttons">{content}</div>
                </div>
            </div>
        </div>
    );
};

export default SuggestedList;
